import downloadJS from 'downloadjs'
import toast from 'react-hot-toast';

const downloadWithFileName = (response) => {
    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition
        .split(';')[1]
        .split('=')[1]
        .replace(/"/g, '')
    downloadJS(response.data, fileName);
};

async function trataErroBlob(error) {
    
    if (error.response?.data instanceof Blob) {
        try {
            const text = await error.response.data.text();
            const json = JSON.parse(text);
            toast.error(json.message);
        } catch {
            toast.error('Erro inesperado ao processar/transformar mensagem de erro.');
        }
    } else {
        toast.error(error.response?.data?.message || 'Erro inesperado');
    }
}

export {
    downloadWithFileName,
    trataErroBlob
}